export default function accountNavigationHandler() {
  document.querySelectorAll(".js-account-nav").forEach((nav) => {
    const toggler = nav.querySelector(".js-nav-toggle");

    if (toggler) {
      toggler.addEventListener("click", (e) => {
        e.preventDefault();
        nav.classList.toggle("account-nav--open");
      });
    }
  });
}
